import 'bootstrap';

function handleImageModalEvents(): void {
  const imageModalElement = document.getElementById('imageModal');
  const imageModalContentElement = document.getElementById('imageModalContent');
  const imageModalLabelElement = document.getElementById('imageModalLabel');

  if (imageModalElement && imageModalContentElement) {
    imageModalElement.addEventListener('show.bs.modal', (event: Event & { relatedTarget: HTMLElement }) => {
      const relatedTarget = event.relatedTarget;
      if (relatedTarget) {
        imageModalContentElement.innerHTML = relatedTarget.innerHTML;
        if (imageModalLabelElement) {
          imageModalLabelElement.innerHTML = relatedTarget.attributes['aria-label'].value
        }
      }
    });

    imageModalElement.addEventListener('hidden.bs.modal', () => {
      imageModalContentElement.innerHTML = '';
      imageModalLabelElement.innerHTML = '';
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  handleImageModalEvents();
});
